export const EXCLUDE = "Exclude";
export const BAGGAGE_TRANSFERS = "Baggage transfers:";
